import { Language } from '@ha/intl';

import { ContentfulSupportedLangs } from '../constants';

export default (lang: Language) => ContentfulSupportedLangs.includes(lang);
